import { ContentGrid } from '@/features/content/ContentGrid';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/content/')({
  staticData: { nav: 'content' },
  validateSearch: z.object({
    kind: z.string().optional(),
    link_status: z.string().optional(),
    sort: z.string().optional(),
    q: z.string().optional(),
  }),
  component: ContentGrid,
});
